import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { PotdCard } from './PotdCard.tsx';

export function PotdPage(): React.JSX.Element {
  return (
    <Box sx={{ maxWidth: 960 }}>
      <Typography variant="h5" gutterBottom>
        Password of the day
      </Typography>
      <Box sx={{ mt: 2 }}>
        <PotdCard />
      </Box>
    </Box>
  );
}

export default PotdPage;
